import { ActionType } from '../../constants/ActionTypes'

export default function DomainsReducer(state = {}, action) {

    switch (action.type) {
        // Add Domain
        case ActionType.CREATE_DOMAIN_BEGIN:
            return {
                ...state,
                inProcess: true,
                error: null
            };

        case ActionType.CREATE_DOMAIN_SUCCESS:
            return {
                ...state,
                inProcess: false,
                id: action.payload.id,
                domain: action.payload.domain,
                status: action.payload.status,
            }

        case ActionType.CREATE_DOMAIN_FAILURE:
            return {
                ...state,
                inProcess: false,
                error: action.payload,
            }

        // Get Domains For Affiliate
        case ActionType.GET_DOMAIN_AFFILIATE_BEGIN:
            return {
                ...state,
                inProcess: true,
                affDomains: [],
                error: null
            };

        case ActionType.GET_DOMAIN_AFFILIATE_SUCCESS:
            return {
                ...state,
                inProcess: false,
                affDomains: action.payload.Data,
            }

        case ActionType.GET_DOMAIN_AFFILIATE_FAILURE:
            return {
                ...state,
                inProcess: false,
                error: action.payload,
            }

        // Get Domains For SubAffiliate
        case ActionType.GET_DOMAIN_SUBAFFILIATE_BEGIN:
            return {
                ...state,
                inProcess: true,
                subAffDomains: [],
                error: null
            };

        case ActionType.GET_DOMAIN_SUBAFFILIATE_SUCCESS:
            return {
                ...state,
                inProcess: false,
                subAffDomains: action.payload.Data,
            }

        case ActionType.GET_DOMAIN_SUBAFFILIATE_FAILURE:
            return {
                ...state,
                inProcess: false,
                error: action.payload,
            }

        // Delete Domain
        case ActionType.DELETE_DOMAIN_BEGIN:
            return {
                ...state,
                inProcess: true
            };

        case ActionType.DELETE_DOMAIN_SUCCESS:
            return {
                ...state,
                inProcess: false
            }

        case ActionType.DELETE_DOMAIN_ERROR:
            return {
                ...state,
                inProcess: true
            }

        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/reducers/mainAffilate/DomainsReducer.js